import React from "react";
import { CheckCircle } from "lucide-react";

export default function MeetingEnded() {
  return (
    <div style={{ height: "100vh", width: "100vw", background: "#06101F", display: "flex",
      flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 14,
      color: "#E8F0FE", fontFamily: "Outfit,sans-serif", textAlign: "center", padding: 20 }}>
      <CheckCircle size={44} style={{ color: "#00E5A3" }}/>
      <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>You've left the meeting</h2>
      <p style={{ margin: 0, color: "#7A93B4", fontSize: 13.5 }}>Thanks for using Hirality Meetings.</p>
      <button onClick={() => window.close()}
        style={{ marginTop: 10, background: "linear-gradient(135deg,#00C8FF,#7C5CFF)", border: "none",
          borderRadius: 8, color: "#fff", fontFamily: "Outfit,sans-serif", fontSize: 13, fontWeight: 600,
          padding: "10px 22px", cursor: "pointer" }}>
        Close Tab
      </button>
    </div>
  );
}
